import React, { useState, useEffect, useContext, } from 'react';
import {useNavigate, useLocation} from "react-router-dom"
import { TextField, Button, Switch, FormControlLabel, CircularProgress, Typography} from '@mui/material';
import { UserContext } from '../contexts/UserContext';
import axios from 'axios';

const Profile = () => {
  const { userInfo, setUserInfo, profileLoading, profileError, fetchUserProfile } = useContext(UserContext);
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    signedToNewsLetterList: false
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [redirect, setRedirect] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const previousPath = location.state?.from?.pathname;
  const from = (previousPath === '/login' || previousPath === '/register') ? '/blog' : previousPath || '/';



  useEffect(() => {
    if (userInfo) {
      console.log(userInfo); // Check if signedToNewsLetterList is being fetched correctly
      setFormData({
        username: userInfo.username || '',
        email: userInfo.email || '',
        password: '', // Leave password empty initially
        signedToNewsLetterList: userInfo.signedToNewsLetterList || false
      });
    }
  }, [userInfo]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSwitchChange = (e) => {
    setFormData({
      ...formData,
      signedToNewsLetterList: e.target.checked
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.put(`${process.env.REACT_APP_API_END_POINT}/profile`, formData, { withCredentials: true });
      setSuccess(true);
      setRedirect(true)
      setUserInfo(response.data); // Update the context with new user info
    } catch (err) {
      setError('Failed to update profile. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (redirect) {
      const timeoutId = setTimeout(() => {
        navigate(from); // Navigate to 'from' path or '/blog' if it was '/login' or '/register'
      }, 500); // Adjust delay as needed
      
      return () => clearTimeout(timeoutId); // Cleanup timeout on component unmount
    }
  }, [redirect, navigate, from]);

  if (profileLoading) {
    return <CircularProgress />;
  }

  if(!userInfo) {
    return  navigate(from);
  }
  return (
    <div style={{ padding: '5rem 20px', maxWidth: '600px', margin: '0 auto',  }}>
      <h2>Edit Profile</h2>
      {error && <Typography variant="body1" my={2} gutterBottom className="msg">{error}</Typography>  }
      {success &&  <Typography variant="body1" my={2} gutterBottom className="msg scuess">Profile updated successfully! </Typography>}
      <form onSubmit={handleSubmit}>
        <TextField
          label="Username"
          name="username"
          value={formData.username}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Email"
          name="email"
          type="email"
          value={formData.email}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <TextField
          label="New Password"
          name="password"
          type="password"
          value={formData.password}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <FormControlLabel
          control={
            <Switch
        
              checked={formData.signedToNewsLetterList}
              onChange={handleSwitchChange}
              name="signedToNewsLetterList"
            />
          }
          label="Subscribe to Newsletter"
        />
        <Button sx={{backgroundColor: '#d3752b'}} variant="contained" color="primary" type="submit" disabled={loading}>
          {loading ? <CircularProgress size={24} /> : 'Update Profile'}
        </Button>
    
  
      </form>
    </div>
  );
};

export default Profile;
